import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import * as folderNotesActionTypes from "features/folder/edit/comments/actionTypes";
import initialState from "reducers/initialState";

const currentFolderReducer = (state = initialState.currentFolder, action) => {
  switch (action.type) {
    case actionTypes.RESET_CURRENT_FOLDER:
      if (action.payload.documentId === state.header.documentId && action.payload.siteId === state.header.siteId) {
        // eslint-disable-line
        return initialState.currentFolder;
      }
      break;

    default:
      return state;
  }
};

const folderHeaderReducer = (state = initialState.currentFolder.header, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FOLDER_HEADER_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_FOLDER_HEADER_SUCCESS: {
      return {
        ...state,
        ...action.payload.folderHeader,
        loading: false,
        loaded: true
      };
    }

    case eventTypes.FOLDER_HEADER_INVALIDATED: {
      return {
        ...state,
        loaded: false,
        loading: false
      };
    }

    case eventTypes.FOLDER_HEADER_UPDATED: {
      return {
        ...state,
        stateId: action.event.eventBody.stateId,
        stateName: action.event.eventBody.stateName,
        stateCode: action.event.eventBody.stateCode
      };
    }

    case folderNotesActionTypes.LOAD_RISK_COMMENT_SUCCESS: {
      return {
        ...state,
        riskComment: {
          ...state.riskComment,
          loading: false,
          loaded: true,
          riskCommentContent: action.payload.riskComment
        }
      };
    }

    case folderNotesActionTypes.LOAD_RISK_COMMENT_STARTED: {
      return {
        ...state,
        riskComment: {
          ...state.riskComment,
          loading: true
        }
      };
    }

    case folderNotesActionTypes.UPDATE_RISK_COMMENT_STARTED: {
      return {
        ...state,
        riskComment: {
          ...state.riskComment,
          saving: true,
          loaded: false
        }
      };
    }

    case folderNotesActionTypes.UPDATE_RISK_COMMENT_SUCCESS: {
      return {
        ...state,
        riskComment: {
          ...state.riskComment,
          riskCommentContent: action.payload.folderNote,
          saving: false
        }
      };
    }

    case actionTypes.LOAD_FOLDER_PARTNER_SUCCESS: {
      return {
        ...state,
        client: {
          ...state.client,
          loaded: true
        }
      };
    }

    case eventTypes.FOLDER_ACTIVE_STEP_CHANGED: {
      return {
        ...state,
        activeStep: action.event.eventBody.activeStep
      };
    }

    default:
      return state;
  }
};

const folderWarningsReducer = (state = initialState.currentFolder.warnings, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FOLDER_WARNINGS_SUCCESS: {
      return Object.assign([], action.payload.documentWarnings, { isValid: true, loaded: true });
    }

    case eventTypes.FOLDER_WARNINGS_CHANGED: {
      return Object.assign([], { isValid: false });
    }

    case eventTypes.DOCUMENT_WORKFLOW_ERROR_DISMISSED: {
      return Object.assign(
        [],
        state.filter(x => x.documentWorkflowErrorId !== action.event.eventBody.documentWorkflowErrorId),
        { isValid: true, loaded: true }
      );
    }

    default:
      return state;
  }
};

const exp = {
  currentFolderReducer,
  folderHeaderReducer,
  folderWarningsReducer
};
export default exp;
